import React from "react";

const Select = ({handleChange, container, error, label, className, options, ...otherProps}) => (
    <div className={container ? (container.class + (error ? ' has-error' : '')) : ('form-group col-12' + (error ? ' has-error' : ''))}>
        {
            label && label.text ?
                (
                    <label className={label.class ? label.class : `form-label`}>
                        <span>{label.text ? label.text : ''}</span>
                        {
                            label.require ?
                                <span>
                                    {label.requireText ? label.requireText : '*'}
                                </span>
                                : ''
                        }
                    </label>
                ) :
                null
        }
        <select
            onChange={handleChange}
            className={(className ? className : "form-control") + (error && error.text ? ' is-invalid' : '')}
            {...otherProps}
        >
            <option value="">یک گزینه را انتخاب کنید ...</option>
            {
                options ?
                    Object.keys(options).map(key =>
                        <option key={key} value={key}>{options[key]}</option>
                    )
                : null
            };

        </select>
        {
            error && error.text ?
                <div className={error.class ? error.class : `invalid-feedback`}>
                    {error.text ? error.text : ''}
                </div>
                :
                null
        }
    </div>

);
export default Select;
